<template>
  <van-popup
    v-model="isShowSelectableSubBranch"
    round
    position="bottom"
    :style="{ height: '50%' }"
  >
    <LongListPicker
      ref="longListPicker"
      :options="SubBranchListOnShow"
      title="选择支行"
      label-key="branchName"
      value-key="branchId"
      :offset="50"
      :error="isListError"
      finished
      @on-cancel="isShowSelectableSubBranch = false"
      @on-confirm="handleSelectSubBranch"
      @on-search="handleSearchSubBranch"
    />
  </van-popup>
</template>

<script>
import Popup from 'vant/lib/popup';
import LongListPicker from '@/components/LongListPicker';
import STATUS from '@/constants/status';

import createWalletApi from '@/api/createWallet';

import 'vant/lib/popup/style';

export default {
  name: 'SubBranchPicker',
  components: {
    LongListPicker,
    [Popup.name]: Popup,
  },
  data() {
    return {
      isShowSelectableSubBranch: false,
      isListError: false,
      SubBranchTotalCount: 0,
      SubBranchList: [],
      SubBranchListOnShow: [],
      keyword: '',
      currentPage: 0,
    };
  },
  methods: {
    checkIsLegalParams({ provinceId, bankId }) {
      if (!provinceId) {
        this.$dialog.toast('前先选择所在省份');
        return false;
      }

      if (!bankId) {
        this.$dialog.toast('前先选择开户行');
        return false;
      }

      return true;
    },

    loadSubBranchList(params) {
      if (!this.checkIsLegalParams(params)) return;

      this.getSubBranchList(params);
      this.isShowSelectableSubBranch = true;
    },

    async getSubBranchList(params) {
      this.loading = true;
      try {
        const { respCode, data, respMsg } = await createWalletApi.getBranchBankList(params);

        if (respCode !== STATUS.SUCCESS) throw new Error(respMsg);

        this.SubBranchList = data;
        this.SubBranchListOnShow = data;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.loading = false;
      }
    },

    handleSelectSubBranch(SubBranch) {
      this.isShowSelectableSubBranch = false;
      this.$emit('on-select-subBranch', SubBranch);
    },

    handleSearchSubBranch(keyword) {
      this.SubBranchListOnShow = this.SubBranchList.filter((subBranch) => subBranch.branchName.indexOf(keyword) !== -1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
